import { Box, CardMedia } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { RequireReduxData } from '~/components/RequireReduxData';
import { allPortalDataDispatchReduxFetches } from '~/hooks/initializeData';
import { useVisible } from '~/hooks/useVisible';
import { InfoBox } from '~/legacy-components/ModulePageFooter/components/InfoBox';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { EmployeesSearch } from './components/EmployeesSearch';
import { LegacyEmailDialog } from './components/LegacyEmailDialog';
import { LegacyFooterMenu } from './components/LegacyFooterMenu';
import { SolaIntel } from './components/SolaIntel';
import { useModulePageFooter } from './useModulePageFooter';
import { useSxStyles } from './useStyles';

export const ModulePageFooter = () => {
  const sxStyles = useSxStyles();
  const {
    isVisible: isEmailOpen,
    hide: hideEmailDialog,
    show: showEmailDialog,
  } = useVisible();
  const {
    showSolaIntelShortcut,
    handleSolaIntelClose,
    openSolaIntel,
    anchorEl,
  } = useModulePageFooter();
  const { t } = useTranslation();

  return (
    <Box sx={sxStyles.footer}>
      <Box sx={sxStyles.footerLeft}>
        <Box sx={sxStyles.logoContainer}>
          <CardMedia
            component="img"
            sx={sxStyles.logoImage}
            src="/v2/img/logoBlueFooter.png"
            alt=""
          />
        </Box>
      </Box>
      <Box sx={sxStyles.footerCenter}>
        <LegacyFooterMenu />
      </Box>
      <Box sx={sxStyles.footerRight}>
        {/* <Box sx={sxStyles.dashboardShortcuts}>
          {showSolaIntelShortcut ? (
            <IconButton
              sx={sxStyles.dashShortcut}
              onClick={handleSolaIntelOpen}
              size="large"
            >
              <School />
            </IconButton>
          ) : undefined}
        </Box> */}
        <RequireReduxData
          required={allPortalDataDispatchReduxFetches}
          renderLoading={(percentage) => (
            <InfoBox
              name={t('solaforceHCM')}
              noMargin={true}
              hasPin={true}
              shadowLeft={true}
              actionElement={
                <LoadingView CircularProgressProps={{ size: '30px' }}>
                  {percentage}
                </LoadingView>
              }
            ></InfoBox>
          )}
        >
          <EmployeesSearch onEmailClick={showEmailDialog} />
          <LegacyEmailDialog open={isEmailOpen} onClose={hideEmailDialog} />
          {openSolaIntel && showSolaIntelShortcut && (
            <SolaIntel
              anchorEl={anchorEl}
              allowClickAwayClose={true}
              onClose={handleSolaIntelClose}
              title={t('solaIntel')}
            />
          )}
        </RequireReduxData>
      </Box>
    </Box>
  );
};
